import { formatDate } from "./invoiceUtils";
import {
  formatCurrency,
  purchaseItemsLabel,
  statusBadgeClass,
} from "../marketplace/marketplaceUtils";

const InvoiceTable = ({ invoices, isReloading, onRevoke, onRestore, onVerify }) => {
  return (
    <table className="table table-hover mb-0 align-middle min-w-[900px]">
      <thead>
        <tr>
          <th>Reference</th>
          <th>Amount</th>
          <th>Learner</th>
          <th>Item</th>
          <th>Status</th>
          <th>Paid At</th>
          <th>Created At</th>
          <th style={{ minWidth: "120px" }}>Access</th>
        </tr>
      </thead>
      <tbody>
        {isReloading && (
          <tr>
            <td colSpan={8}>
              <div className="d-flex justify-content-center align-items-center tableLoader">
                <div className="loader"></div>
              </div>
            </td>
          </tr>
        )}
        {!isReloading && invoices.length === 0 && (
          <tr>
            <td colSpan={8}>
              <div className="d-flex justify-content-center align-items-center tableLoader">
                No purchases to display
              </div>
            </td>
          </tr>
        )}

        {invoices.map((invoice) => {
          const revoked = Boolean(invoice.revokedAt);
          return (
            <tr key={invoice.id}>
              <td className="text-start font-monospace">{invoice.reference}</td>
              <td>{formatCurrency(invoice.amount, invoice.currency || "NGN")}</td>
              <td>
                <div className="d-flex flex-column">
                  <span>{invoice.learner?.name || "—"}</span>
                  <small className="text-muted">{invoice.learner?.email || ""}</small>
                </div>
              </td>
              <td>
                <div className="d-flex flex-column">
                  <span>{purchaseItemsLabel(invoice)}</span>
                  <small className="text-muted">{invoice.type || ""}</small>
                </div>
              </td>
              <td>
                <span className={`badge ${statusBadgeClass(invoice.status)}`}>
                  {invoice.status}
                </span>
                {revoked && <span className="badge bg-secondary ms-2">ACCESS REVOKED</span>}
              </td>
              <td>{formatDate(invoice.paidAt)}</td>
              <td>{formatDate(invoice.createdAt)}</td>
              <td>
                <div className="d-flex flex-wrap justify-content-end gap-2">
                  {(invoice.status === "PENDING" || invoice.status === "PROCESSING") && (
                    <>
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => onVerify(invoice, false)}
                      >
                        Verify
                      </button>
                      <button
                        className="btn btn-outline-warning btn-sm"
                        onClick={() => onVerify(invoice, true)}
                      >
                        Force
                      </button>
                    </>
                  )}
                  {revoked ? (
                    <button
                      className="btn btn-outline-success btn-sm"
                      onClick={() => onRestore(invoice)}
                    >
                      Restore
                    </button>
                  ) : (
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => onRevoke(invoice)}
                      disabled={invoice.status !== "COMPLETED"}
                      title={
                        invoice.status !== "COMPLETED"
                          ? "Only completed purchases can have access revoked"
                          : undefined
                      }
                    >
                      Revoke
                    </button>
                  )}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default InvoiceTable;
